import { SETTINGS_DATA_SOURCE_TYPES_ARRAY } from "@infinode/components/settings/constants";
import siteConfig from "@iso/config/site.config";
import {
  getGetRequestInfo,
  getDeleteRequestInfo,
  getPutRequestInfo,
  getPostRequestInfo,
  getRequestGeneratorFunction
} from "@iso/utils/connectUtils";
import { upperFirst } from "lodash";
import { put } from "redux-saga/effects";
import zoneUrls from "src/infinode/constants/urls/zoneUrls";
import sitesActions from "../sites/actions";
import zonesActions from "./actions";
import actions from "./actions";

const {
  getZoneList,
  getZoneUrl,
  getZoneDemandUrl,
  getZoneDLCUrl,
  getZoneMetersUrl,
  getUpdateZoneTypeUrl,
  getAddZoneDataSourceUrl,
  getRemoveZoneDataSourceUrl
} = zoneUrls;

const onGetZoneListRequest = ({ token, siteId }) =>
  fetch(`${siteConfig.apiUrl}${getZoneList(siteId)}`, getGetRequestInfo(token)).then(response => response);

const onGetZoneListSuccess = function* (resultBody, params) {
  if (resultBody.zones !== undefined) {
    yield put({
      type: actions.GET_ZONES_SUCCESS,
      zones: resultBody.zones,
      siteId: params.siteId
    });
    return true;
  }
  return false;
};

const getZoneListRequest = getRequestGeneratorFunction(
  actions.GET_ZONES_REQUEST,
  actions.ZONES_ERROR,
  onGetZoneListRequest,
  onGetZoneListSuccess
);

const onGetZoneRequest = ({ token, id, siteId }) =>
  fetch(`${siteConfig.apiUrl}${getZoneUrl(siteId)}/${id}`, getGetRequestInfo(token)).then(response => response);

const onGetZoneSuccess = function* (resultBody, params) {
  if (resultBody.zone) {
    yield put({
      type: actions.GET_ZONE_SUCCESS,
      zone: resultBody.zone,
      siteId: params.siteId
    });
    return true;
  }
  return false;
};

const getZoneRequest = getRequestGeneratorFunction(
  actions.GET_ZONE_REQUEST,
  actions.ZONES_ERROR,
  onGetZoneRequest,
  onGetZoneSuccess
);

const onDeleteZoneRequest = ({ token, id, siteId }) =>
  fetch(`${siteConfig.apiUrl}${getZoneUrl(siteId)}/${id}`, getDeleteRequestInfo(token)).then(response => response);

const onDeleteZoneSuccess = function* (resultBody, params) {
  yield console.log(resultBody);
  if (resultBody === true) {
    yield put({
      type: actions.DELETE_ZONE_SUCCESS,
      id: params.id,
      siteId: params.siteId
    });

    if (params.isSingleZone) {
      yield updateSiteDataSourceByMainZone(params.token, params.siteId, params.id, null);
    }

    return true;
  }
  return false;
};

const deleteZoneRequest = getRequestGeneratorFunction(
  actions.DELETE_ZONE_REQUEST,
  actions.ZONES_ERROR,
  onDeleteZoneRequest,
  onDeleteZoneSuccess
);

const onUpdateZoneRequest = ({ token, zone, siteId }) =>
  fetch(`${siteConfig.apiUrl}${getZoneUrl(siteId)}/${zone.id}`, getPutRequestInfo(zone, token)).then(
    response => response
  );

const onUpdateZoneSuccess = function* (resultBody, params) {
  if (resultBody.zone) {
    yield put({
      type: actions.UPDATE_ZONE_SUCCESS,
      zone: resultBody.zone,
      siteId: params.siteId
    });
    return true;
  }
  return false;
};

const updateZoneRequest = getRequestGeneratorFunction(
  actions.UPDATE_ZONE_REQUEST,
  actions.ZONES_ERROR,
  onUpdateZoneRequest,
  onUpdateZoneSuccess
);

const onUpdateZoneTypeRequest = ({ token, zone, siteId }) =>
  fetch(`${siteConfig.apiUrl}${getUpdateZoneTypeUrl(siteId, zone.id)}`, getPutRequestInfo(zone, token)).then(
    response => response
  );

const updateSiteDataSourceByMainZone = function* (token, siteId, oldMainZoneId, newMainZoneId) {
  const types = SETTINGS_DATA_SOURCE_TYPES_ARRAY;
  if (oldMainZoneId || newMainZoneId) {
    for (let i = 0; i < types.length; i++) {
      const t = types[i];
      if (oldMainZoneId) {
        yield put(sitesActions.removeSiteDataSource(token, siteId, oldMainZoneId, null, t));
      }
      if (newMainZoneId) {
        yield put(sitesActions.addSiteDataSource(token, siteId, newMainZoneId, null, t, true));
      }
    }
  }
};

const onUpdateZoneTypeSuccess = function* (resultBody, params) {
  if (resultBody) {
    yield put({
      type: actions.UPDATE_ZONE_TYPE_SUCCESS,
      zone: params.zone
    });

    // update the data sources of the site
    yield updateSiteDataSourceByMainZone(params.token, params.siteId, (params.zone.zoneType==='MainZone'||params.oldMainZoneId===params.zone.id)?params.oldMainZoneId:null, params.zone.zoneType==='MainZone'?params.zone.id:null);
    return true;
  }
  return false;
};

const updateZoneTypeRequest = getRequestGeneratorFunction(
  actions.UPDATE_ZONE_TYPE_REQUEST,
  actions.ZONES_ERROR,
  onUpdateZoneTypeRequest,
  onUpdateZoneTypeSuccess
);

const onCreateZoneRequest = ({ token, zone, siteId }) =>
  fetch(`${siteConfig.apiUrl}${getZoneUrl(siteId)}`, getPostRequestInfo(zone, token)).then(response => response);

const onCreateZoneSuccess = function* (resultBody, params) {
  if (resultBody.zone) {
    yield put({
      type: actions.CREATE_ZONE_SUCCESS,
      zone: resultBody.zone,
      siteId: params.siteId
    });

    // update the data sources of the site when it it the single zone type
    if (params.isSingleZone) {
      yield updateSiteDataSourceByMainZone(params.token, params.siteId, null, resultBody.zone.id);
    }

    return true;
  }
  return false;
};

const createZoneRequest = getRequestGeneratorFunction(
  actions.CREATE_ZONE_REQUEST,
  actions.ZONES_ERROR,
  onCreateZoneRequest,
  onCreateZoneSuccess
);

const onUpdateZoneDemandConfigRequest = ({ token, siteId, zoneId, demandSwitch }) =>
  fetch(
    `${siteConfig.apiUrl}${getZoneDemandUrl(siteId, zoneId)}`,
    getPutRequestInfo({ siteId, zoneId, demandSwitch }, token)
  ).then(response => response);

const onUpdateZoneDemandConfigSuccess = function* (resultBody, { siteId, zoneId, demandSwitch }) {
  if (resultBody) {
    yield put({
      type: actions.UPDATE_ZONE_DEMAND_CONFIG_SUCCESS,
      siteId,
      zoneId,
      demandSwitch
    });
    return true;
  }
  return false;
};

const onUpdateZoneDLCConfigRequest = ({ token, siteId, zoneId, DLCId }) =>
  fetch(
    `${siteConfig.apiUrl}${getZoneDLCUrl(siteId, zoneId)}`,
    getPutRequestInfo({ siteId, zoneId, DLCId }, token)
  ).then(response => response);

const onUpdateZoneDLCConfigSuccess = function* (resultBody, { siteId, zoneId, DLCId }) {
  if (resultBody) {
    yield put({
      type: actions.UPDATE_ZONE_DLC_CONFIG_SUCCESS,
      siteId,
      zoneId,
      DLCId
    });
    return true;
  }
  return false;
};

const onUpdateZoneMetersConfigRequest = ({ token, siteId, zoneId, toggledMeterId }) =>
  fetch(
    `${siteConfig.apiUrl}${getZoneMetersUrl(siteId, zoneId)}`,
    getPutRequestInfo({ siteId, zoneId, toggledMeterId }, token)
  ).then(response => response);

const onUpdateZoneMetersConfigSuccess = function* (resultBody, { token, siteId, zoneId, toggledMeterId }) {
  if (resultBody) {
    yield put({
      type: actions.UPDATE_ZONE_METERS_CONFIG_SUCCESS,
      siteId,
      zoneId,
      toggledMeterId
    });
    yield put (zonesActions.getZones(token,siteId))
    return true;
  }
  return false;
};




const fixDataSourceTypeLabelForServerSide = circuitDataSourceList => {
  return circuitDataSourceList.map(ds => {
    let newDS = Object.assign({}, ds);
    newDS.dataSourceType = upperFirst(newDS.dataSourceType);
    return newDS;
  });
};

const onAddZoneDataSourceRequest = ({ token, siteId, zoneId, circuitDataSourceList }) =>
  fetch(
    `${siteConfig.apiUrl}${getAddZoneDataSourceUrl(siteId, zoneId)}`,
    getPutRequestInfo(
      { zoneId, circuitDataSourceList: fixDataSourceTypeLabelForServerSide(circuitDataSourceList) },
      token
    )
  ).then(response => response);

const onAddZoneDataSourceSuccess = function* (resultBody, { siteId, zoneId, circuitDataSourceList }) {
  if (resultBody) {
    yield put({
      type: actions.ADD_ZONE_DATA_SOURCE_SUCCESS,
      siteId,
      zoneId,
      circuitDataSourceList
    });
    return true;
  }
  return false;
};

const updateZoneDemandConfigRequest = getRequestGeneratorFunction(
  actions.UPDATE_ZONE_DEMAND_CONFIG_REQUEST,
  actions.ZONES_ERROR,
  onUpdateZoneDemandConfigRequest,
  onUpdateZoneDemandConfigSuccess
);

const updateZoneDLCConfigRequest = getRequestGeneratorFunction(
  actions.UPDATE_ZONE_DLC_CONFIG_REQUEST,
  actions.ZONES_ERROR,
  onUpdateZoneDLCConfigRequest,
  onUpdateZoneDLCConfigSuccess
);

const updateZoneMetersConfigRequest = getRequestGeneratorFunction(
  actions.UPDATE_ZONE_METERS_CONFIG_REQUEST,
  actions.ZONES_ERROR,
  onUpdateZoneMetersConfigRequest,
  onUpdateZoneMetersConfigSuccess
);

const addZoneDataSourceRequest = getRequestGeneratorFunction(
  actions.ADD_ZONE_DATA_SOURCE_REQUEST,
  actions.ZONES_ERROR,
  onAddZoneDataSourceRequest,
  onAddZoneDataSourceSuccess
);

const onRemoveZoneDataSourceRequest = ({ token, siteId, zoneId, circuitDataSourceList }) =>
  fetch(
    `${siteConfig.apiUrl}${getRemoveZoneDataSourceUrl(siteId, zoneId)}`,
    getPutRequestInfo(
      { zoneId, circuitDataSourceList: fixDataSourceTypeLabelForServerSide(circuitDataSourceList) },
      token
    )
  ).then(response => response);

const onRemoveZoneDataSourceSuccess = function* (resultBody, { siteId, zoneId, circuitDataSourceList }) {
  if (resultBody) {
    yield put({
      type: actions.REMOVE_ZONE_DATA_SOURCE_SUCCESS,
      siteId,
      zoneId,
      circuitDataSourceList
    });
    return true;
  }
  return false;
};

const removeZoneDataSourceRequest = getRequestGeneratorFunction(
  actions.REMOVE_ZONE_DATA_SOURCE_REQUEST,
  actions.ZONES_ERROR,
  onRemoveZoneDataSourceRequest,
  onRemoveZoneDataSourceSuccess
);

export default {
  getZoneListRequest,
  getZoneRequest,
  deleteZoneRequest,
  updateZoneRequest,
  createZoneRequest,
  updateZoneDemandConfigRequest,
  updateZoneDLCConfigRequest,
  updateZoneMetersConfigRequest,
  updateZoneTypeRequest,
  addZoneDataSourceRequest,
  removeZoneDataSourceRequest
};
